import React from "react"
import { MenuItem, TextField, Box, TextFieldProps } from "@mui/material"

import MeasureCylinderDialog from "components/Dialogs/MeasureCylinderDialog"

import useOuterLengthsConfiguration from "@secureo/common/hooks/cylinderConfigurations/useOuterLengthsConfiguration"

const OuterLengthConfigurationInput = ({
	outerLengths,
	selectedOuterLength,
	onOuterLengthChange,
	showMeasureCylinderDialog = false,
	disabled,
	margin = "normal",
}: Props) => {
	const { outerLengthInputProps, availableOuterLengths } = useOuterLengthsConfiguration(
		outerLengths,
		selectedOuterLength,
		onOuterLengthChange,
	)

	return (
		<div>
			{showMeasureCylinderDialog && (
				<Box mb={-1} style={{ display: "flex", alignItems: "center" }}>
					<MeasureCylinderDialog />
				</Box>
			)}
			<TextField
				id="outerLength"
				label="Außenlänge"
				{...outerLengthInputProps}
				margin={margin}
				variant="filled"
				select
				fullWidth
				disabled={disabled}
			>
				{availableOuterLengths.map((outerLength) => (
					<MenuItem key={outerLength} value={outerLength}>
						{outerLength} mm
					</MenuItem>
				))}
			</TextField>
		</div>
	)
}

interface Props {
	outerLengths: number[]
	selectedOuterLength: number
	onOuterLengthChange: (selectedOuterLength: number) => void
	showMeasureCylinderDialog?: boolean
	disabled?: boolean
	margin?: TextFieldProps["margin"]
}

export default OuterLengthConfigurationInput
